export function useCacheRoute(seconds: number = 5, callback?: (helper: any) => void) {
  const { query } = useRoute()
  const openid = query.n || query.openid
  const final = query.final
  useRouteCache((helper) => {
    if (!openid && !final)
      callback ? callback(helper) : helper.setCacheable().setMaxAge(seconds)
  })
}
